import axios from 'axios'
import errorCode from './errorCode'

axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';// application/x-www-form-urlencoded;charset=UTF-8
const service = axios.create({
    // baseURL: config.BASE_URL,//这里请求的基础路径不写死，可能出现请求多个后台服务
    timeout: 10000
});

/**
 * @description 请求拦截器
 * @param config 请求参数
 */
service.interceptors.request.use(config => {
    const token = sessionStorage.getItem('Authorization');
    // 如果 token 存在
    if (token) {
      config.headers['Authorization'] = token;
    }
    if((config.method === 'get' || config.method === 'delete') && config.params){
        let url = config.url + '?' + config.params;
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    console.log(error);
    Promise.reject(error)
});

/**
 * @description 响应拦截器
 * @param res 响应结果
 */
service.interceptors.response.use(res => {
    if (res.data.code == 200){
        return res.data.obj;
    }else{
        console.log({code: res.data.code, message: res.data.message});
        return Promise.reject({code: res.data.code, message: res.data.message});
    }
    
},error => {
    console.log({error});
    if(errorCode[error.response.status]){
        return Promise.reject({message: errorCode[error.response.status] });
    }else{
        return Promise.reject({message: ''});
    }

    
});

export default service;